import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ReactDOM from "react-dom";
import AlertStore from "AlertStore";
import _ from "underscore";
import ScrollBar from "ScrollBar";
import StringUtil from "StringUtil";
import AlertActions from 'AlertActions';
import LocalizationStore from 'LocalizationStore';

export default class AlertColumnSetDetails extends Component {
    constructor(props) {
        super(props);
        this.selectColumnSet = this.selectColumnSet.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.columnSetDetails = null;//this.props.columnSetDetails;
        this.columnSetTitle = null;
        this.menuOpen = false;

        this.state = {
            showModal: false
        }

        this.columnsetChildItems = AlertStore.getColumnsetChildItems();;
    }

    UNSAFE_componentWillReceiveProps() {
        this.columnsetChildItems = AlertStore.getColumnsetChildItems();
    }

    closeModal() {
        this.setState({ showModal: false });
    }

    openModal() {
        this.setState({ showModal: true });
    }

    selectColumnSet(e) {
        let nodeId = ReactDOM.findDOMNode(e.target).getAttribute('data-node-id');

        let columnSetDetails = _.find(this.columnsetChildItems, (column) =>
            parseInt(nodeId) === parseInt(column.colsetId)
        );

        this.props.closeColumnSetWindow();

        AlertActions.selectColumnSet(columnSetDetails, this.props.parentColumnSetName);

        e.preventDefault();
    }

    renderColumnSetDetails() {

        let self = this;
        this.columnSetTitle = this.props.parentColumnSetName;
        return (<ul className="list-group">
            {
                _.map(this.columnsetChildItems, (column, key) => {

                    let activeClass = (!StringUtil.isEmpty(self.props.selectedColumnSet) && self.props.selectedColumnSet.colsetId == column.colsetId) ? 'active' : '';
                    let activeNode = (!StringUtil.isEmpty(self.props.selectedColumnSet) && self.props.selectedColumnSet.colsetId == column.colsetId) ? <span className="icn-right-icon"></span> : '';

                    let columnName = column.isShared ? "Shared - " + column.colsetName : column.colsetName;

                    return (
                        <li key={key} className={"list-group-item " + activeClass}>
                            <a className="panal-a" href="javascript:void(0);" onClick={self.selectColumnSet} data-node-id={column.colsetId} title={LocalizationStore.getTranslatedData("ColumnSet_"+columnName,columnName)}>
                                {activeNode}
                                <span className={column.isShared ? "icn-share pull-left" : "icn-fa-file-text-p pull-left marr0"}></span>
                                {LocalizationStore.getTranslatedData("ColumnSet_"+columnName,columnName)}
                            </a>
                        </li>
                    );
                })
            }
        </ul>);
    }


    render() {
        let columnSetDetails = this.renderColumnSetDetails();

        return (
            <div id="alertColumnDialog" >
                <Modal className="modal-popup alert-column-dialog" show={true} style={{ left: this.props.left, top: this.props.top }}>
                    <Modal.Header id="alertColumnSetDetailsModalHeader">
                        <Modal.Title>
                            <span className="icn-back-btn" id="alertColumnSetBackButton" data-effect="fadeOut" onClick={this.props.toggleDetailDailog}>{LocalizationStore.getTranslatedData("back","Back")}</span>
                            <span className="cap-header">{LocalizationStore.getTranslatedData("ColumnSet_" + this.columnSetTitle,this.columnSetTitle)}</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body id="alertColumnSetDetailsModalBody">
                        <div className="modal-area column-geo-alert custom-scroll-light" onMouseDown={this.props.handleMouseDownColumnsetModal} onMouseUp={this.props.handleMouseuPColumnsetModal}>
                            <div className="custom-scroll">
                                <div id="alertColumnSetVerticalScroll1">
                                    {columnSetDetails}
                                </div>
                            </div>
                        </div>
                        <ScrollBar scrollId="alertColumnSetVerticalScroll1" vScroll={true} />
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}



